import styled from 'styled-components';

import { Title } from '@xsolla/ui-core';

export const TitleHeader = styled(Title)`
  text-align: center;
  justify-content: center;
`;

export const DeleteFormContent = styled.div`
  padding: 43px 30px 20px;
  display: flex;
  justify-content: center;
  flex-direction: column;

  p {
    text-align: center;
  }
`;

export const IconWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 11px;
`;

export const CheckboxWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  font-weight: bold;
`;
